export default __webpack_public_path__ + "static/media/artistLogo4.5c98698f.png";